import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useUnlockApplicationUserQuery = () => {
  const { mutateAsync, isPending } = useMutation((username: string) =>
    api.post(API_URL.APPLICATION_USER_UNLOCK_BY_USERNAME(username))
  );

  return {
    unlockApplicationUser: mutateAsync,
    isPending,
  };
};

export default useUnlockApplicationUserQuery;
